import React, { useMemo } from 'react'
import { createContext } from "react";
import { useFetchPublic, platformWeb } from 'src/consumer/services/index.js';

export const MentorLocalizationContext = createContext(null)

export const MentorLocalizationProvider = ({ children }) => {

    const { loading: localizedDataLoading, data: localizedData, error: localizedDataError } = useFetchPublic('/api/external/locale', `&platformType=${platformWeb}&product=com.aumhum.mentor`, "web");

    const value = useMemo(
        () => ({ localizedDataLoading, localizedData, localizedDataError }),
        [localizedDataLoading, localizedData, localizedDataError]
    )

    return (
        <MentorLocalizationContext.Provider value={value} >
            {children}
        </MentorLocalizationContext.Provider>
    )
}